export default __webpack_public_path__ + "static/media/9.1565f092.jpg";